import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {getPriceWithCurrency, toFixedPrice} from "../../../../../misc/helpers";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import LookFeaturePrice from "./lookFeaturePrice";

const LookFeaturePairPrice = (props) => {

  const {lookFeature, fabricatorSettings, wizardGroup} = props;

  if (fabricatorSettings.showSalePrices && (typeof lookFeature.dbFeature.fabricatorCost == "number")
    && (lookFeature.dbFeature.fabricatorCost !== lookFeature.dbFeature.cost)) {
    return (
      <div className="lk-price__pair">
        <strike className="lk-price__pair-old">
          {/* old price is cost property, the new one is fabricatorCost*/}
          {getPriceWithCurrency(fabricatorSettings, toFixedPrice(lookFeature.dbFeature.cost), lookFeature)}
        </strike>
        <span className="lk-price__pair-new">
          <LookFeaturePrice lookFeature={lookFeature}
                            wizardGroup={wizardGroup}
                            mainContentPrice={true} />
        </span>
      </div>
    )
  }

  return <LookFeaturePrice lookFeature={lookFeature}
                           wizardGroup={wizardGroup}
                           mainContentPrice={true}
                           className="lk-feature__price-text" />
};

LookFeaturePairPrice.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;
  return {
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps)(LookFeaturePairPrice)
